<template>
    <div class="w-full px-3">
        <div class="py-4 items-center flex">
            <div class="w-1/12 lg:w-2/12">
                <div><auction-state :state="'active'"/></div>
            </div>
            <div class="w-5/12 block lg:flex">
                <div class="w-full lg:w-3/5 pr-3 lg:pr-0">
                    <div class="text-3xl text-right">{{ currentLevelPrice | toCurrency }}</div>
                </div>
                <div class="w-full lg:w-2/5 pr-3 lg:pr-0">
                    <div class="pl-3 text-right lg:text-left">{{$t('pages.dashboard.components.auction_current_level.price')}}</div>
                </div>
            </div>
            <div class="w-6/12 lg:w-5/12 block lg:flex">
                <div class="w-full lg:w-2/5 pr-3 pr-3 lg:pr-0">
                    <div class="text-3xl text-right">{{ currentLevelSoldQuantity }} / {{ currentLevelPlannedQuantity }}</div>
                </div>
                <div class="w-full lg:w-3/5 pr-3 lg:pr-0">
                    <div class="text-right lg:text-left">{{$t('pages.dashboard.components.auction_current_level.quantity_label')}}</div>
                </div>
            </div>
        </div>

        <div class="py-4 items-center flex border-t border-gray-200">
            <div class="w-1/12 lg:w-2/12">
                <div><auction-state :state="'next'"/></div>
            </div>
            <div class="w-5/12 block lg:flex">
                <div class="w-full lg:w-3/5 pr-3 lg:pr-0">
                    <div class="text-3xl text-right">{{ nextLevelPrice | toCurrency }}</div>
                </div>
                <div class="w-full lg:w-2/5 pr-3 lg:pr-0">
                    <div class="pl-3 text-right lg:text-left">{{$t('pages.dashboard.components.auction_current_level.price')}}</div>
                </div>
            </div>
            <div class="w-6/12 lg:w-5/12 block lg:flex">
                <div class="w-full lg:w-2/5 pr-3 pr-3 lg:pr-0">
                    <div class="text-3xl text-right">{{ nextLevelQuantity }}</div>
                </div>
                <div class="w-full lg:w-3/5 pr-3 lg:pr-0">
                    <div class="text-right lg:text-left">{{$t('pages.dashboard.components.auction_current_level.quantity_plan_label')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeadline from "../../../Shared/PageHeadline";
import AuctionState from "../../../Shared/Auction/AuctionState";

export default {
    components: {AuctionState, PageHeadline},
    props: {
        name: String,
        currentLevelPrice: Number,
        currentLevelSoldQuantity: Number,
        currentLevelPlannedQuantity: Number,
        nextLevelPrice: Number,
        nextLevelQuantity: Number
    }
}
</script>
